import * as React from 'react';

function SvgCreateAddress(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 17" {...props}>
      <path d="M13.447 4.13a6.738 6.738 0 00-1.504-2.152A7.132 7.132 0 007 0c-.943 0-1.857.178-2.72.53a7.01 7.01 0 00-2.223 1.446A6.759 6.759 0 00.553 4.128 6.536 6.536 0 000 6.768c0 1.312.318 2.62.943 3.88.502 1.013 1.204 2 2.088 2.94a16.776 16.776 0 003.546 2.844.834.834 0 00.843 0 16.776 16.776 0 003.545-2.845c.884-.937 1.586-1.926 2.088-2.94C13.682 9.39 14 8.085 14 6.77a6.53 6.53 0 00-.553-2.64zM7 15.12c-1.24-.78-5.645-3.864-5.645-8.35 0-1.449.585-2.81 1.648-3.836A5.724 5.724 0 017 1.339c1.511 0 2.93.567 3.997 1.597a5.288 5.288 0 011.648 3.834c0 4.486-4.405 7.57-5.645 8.35z" />
      <path d="M7 3.818a3.182 3.182 0 100 6.364 3.182 3.182 0 000-6.364zm1.432 4.614A2.018 2.018 0 017 9.025a2.02 2.02 0 01-1.432-.593A2.018 2.018 0 014.975 7c0-.54.212-1.049.593-1.432A2.01 2.01 0 017 4.975c.54 0 1.049.21 1.432.593s.593.891.593 1.432c0 .54-.21 1.049-.593 1.432z" />
    </svg>
  );
}

export default SvgCreateAddress;
